import { Pipe, PipeTransform } from '@angular/core';

import { Capability } from '../models/role';

@Pipe({
  name: 'checkCapability',
})
export class CheckCapabilityPipe implements PipeTransform {

  transform(capabilities: Capability[], capabilityNameToCheck?: string): boolean {
    if (typeof capabilityNameToCheck !== 'string') {
      throw new Error('[checkCapability - pipe] Cannot use this pipe without a string');
    }
    return capabilities.map((c) => c.name).includes(capabilityNameToCheck);
  }

}
